import { BOOKING_STATUS, BOOKING_ATTENDANCE } from '@lgc/database/types/domains/booking';

// src/cancellation/policy.ts
var CANCELLATION_LEAD_HOURS = 0;
var CANCELLATION_CUTOFF_ANCHOR = "end";
var CANCELLATION_CUTOFF_GRACE_MINUTES = 0;
var MEMBER_CANCELLABLE_STATUSES = [
  BOOKING_STATUS.PENDING,
  BOOKING_STATUS.CONFIRMED
];
var CHECKED_IN_CANCEL_MESSAGE = "You're checked in, so this booking can no longer be cancelled.";
var MINUTE_MS = 60 * 1e3;
function resolveCancellationEligibility(booking, now) {
  if (booking.status === BOOKING_STATUS.CANCELLED) {
    return { allowed: false, reason: "already_cancelled", message: "Booking is already cancelled", field: "status" };
  }
  if (booking.status === BOOKING_STATUS.COMPLETED) {
    return { allowed: false, reason: "completed", message: "Cannot cancel completed bookings", field: "status" };
  }
  if (!MEMBER_CANCELLABLE_STATUSES.some((s) => s === booking.status)) {
    return {
      allowed: false,
      reason: "not_cancellable",
      message: "This booking can no longer be cancelled.",
      field: "status"
    };
  }
  if (booking.attendance === BOOKING_ATTENDANCE.ATTENDED) {
    return { allowed: false, reason: "checked_in", message: CHECKED_IN_CANCEL_MESSAGE, field: "attendance" };
  }
  const nowMs = now.getTime();
  const anchor = booking.endTime ;
  const cutoffMs = anchor.getTime() + CANCELLATION_CUTOFF_GRACE_MINUTES * MINUTE_MS;
  if (nowMs >= cutoffMs) {
    return {
      allowed: false,
      reason: "after_cutoff",
      message: "This booking can no longer be cancelled because it has already taken place.",
      field: "endTime" 
    };
  }
  return { allowed: true };
}

export { CANCELLATION_CUTOFF_ANCHOR, CANCELLATION_CUTOFF_GRACE_MINUTES, CANCELLATION_LEAD_HOURS, CHECKED_IN_CANCEL_MESSAGE, MEMBER_CANCELLABLE_STATUSES, resolveCancellationEligibility };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map